//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    // 首页设置的相关信息
    homeSettingInfo: {
      type: Object,
      default: () => {},
    },
    mFlage: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {},
}
